import React, { createContext, useMemo } from "react";

export interface ContextProps {
  checkboxValue: boolean;
  open: boolean;
  onClose: () => unknown;
  onOpen: () => unknown;
  setDontShowAgain: (dontShowAgain: boolean) => unknown;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop: () => void = () => {};

export const PremiumModalContext = createContext<ContextProps>({
  checkboxValue: false,
  open: false,
  onClose: noop,
  onOpen: noop,
  setDontShowAgain: noop,
});

export const PremiumModalContextProvider: React.FC = (props) => {
  const value = useMemo<ContextProps>(
    () => ({
      checkboxValue: false,
      open: false,
      onClose: noop,
      onOpen: noop,
      setDontShowAgain: noop,
    }),
    []
  );

  return (
    <PremiumModalContext.Provider value={value}>
      {props.children}
    </PremiumModalContext.Provider>
  );
};
